<template>
  <section class="container mx-auto px-4 md:px-0 py-6">
    <div
      class="grid gap-4 sm:gap-6 md:gap-8"
      :class="gridColsClass"
      aria-hidden="true"
    >
      <div
        v-for="n in cards"
        :key="n"
        class="flex flex-col rounded-2xl border border-slate-100 bg-white shadow-sm overflow-hidden animate-pulse"
      >
        <!-- Фото -->
        <div class="relative w-full pb-[120%] bg-slate-100" />

        <!-- Текстова частина -->
        <div class="flex flex-col gap-2 px-4 py-3">
          <div class="h-4 w-3/4 rounded-full bg-slate-100" />
          <div class="h-4 w-1/2 rounded-full bg-slate-100" />
          <div class="mt-3 h-9 w-full rounded-full bg-slate-100" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  cards: {
    type: Number,
    default: 8,
  },
});

/**
 * Той самий грід, що й на головній/у каталозі,
 * щоб не було «стрибків» при заміні скелетону на реальні картки.
 */
const gridColsClass = computed(() => {
  // просто повертаємо tailwind-класи
  return "grid-cols-2 md:grid-cols-3 xl:grid-cols-4";
});
</script>

<style scoped lang="scss">
/* трішки згладжуємо миготіння фону */
.animate-pulse {
  animation-duration: 1.2s;
}
</style>
